import React, { useEffect, useState } from "react";
import { api, BROCHURE_URL } from "@/lib/api";
import { Download, FileText } from "lucide-react";

export default function BrochureCta({ variant = "card", testId = "brochure-cta" }) {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    api
      .get("/brochure/status")
      .then((r) => setAvailable(!!r.data?.available))
      .catch(() => setAvailable(false));
  }, []);

  if (variant === "inline") {
    return (
      <a
        href={BROCHURE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          if (!available) {
            e.preventDefault();
            window.location.href = "/contact";
          }
        }}
        className="btn-secondary"
        data-testid={testId}
      >
        <Download size={14} />
        {available ? "Download Brochure" : "Request Brochure"}
      </a>
    );
  }

  return (
    <div className="industrial-card p-6 md:p-7 flex items-center gap-5" data-testid={testId}>
      <div className="hidden md:flex w-14 h-14 items-center justify-center bg-[#e63946]/10 border border-[#e63946]/30">
        <FileText size={22} className="text-[#e63946]" />
      </div>
      <div className="flex-1">
        <div className="eyebrow">Product brochure</div>
        <div className="font-display text-base md:text-lg uppercase mt-2 leading-tight">
          {available ? "Download the VPS product brochure (PDF)" : "Brochure available on request"}
        </div>
      </div>
      {available ? (
        <a
          href={BROCHURE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
          data-testid={`${testId}-download`}
        >
          <Download size={14} /> Download
        </a>
      ) : (
        <a href="/contact" className="btn-secondary" data-testid={`${testId}-request`}>
          Request
        </a>
      )}
    </div>
  );
}
